<!--选择城市-->
<template>
  <div>
    <div class="home-nav">
      <div class="home-nav-item home-nav-flex">
        <div class="nav-item-btn" @click="goRecharge">
          <img
            src="../../../../picture/index/nav-recharge.png"
            class="nav-icon"
          />
        </div>
      </div>
      <div class="home-nav-item" @click="scanCode">
        <div class="wx-coed-btn">
          <img
            src="../../../../picture/index/nav-code.png"
            class="nav-code-icon"
          />扫码充电
        </div>
      </div>
      <div class="home-nav-item home-nav-flex">
        <div class="nav-item-btn" @click="goMy">
          <img src="../../../../picture/index/nav-my.png" class="nav-icon" />
        </div>
      </div>
    </div>

    <div class="map-right ios-margin-bottom" :class="isMore?'move':''">
      <div
        class="map-location"
        @click="getLocation"
        v-if="isMapShow == 1"
      >
        <img
          class="map-location-icon"
          src="../../../../picture/index/location.png"
         />
      </div>
      <div class="map-id" @click="inputId">
        <img
          class="map-id-icon"
          src="../../../../picture/index/input-id.png"
         />
        <div class="map-item-text">桩ID</div>
      </div>
    </div>
  </div>
</template>

<script>

import {scanCodeRecharge} from '@/common/common-data';
export default {
  name: "pi-home-nav",
  components: {},
  props: {
    isMapShow: {
      type: Number,
      default: 1
    },
    isMore: {
      type: Boolean,
      default: false
    }
  },
  watch: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {
    goMy() {
      this.$router.push("/my");
    },
    goRecharge() {
      this.$router.push("/money");
    },
    scanCode() {
       scanCodeRecharge();
    },
    getLocation(){
      this.$emit('location')
    },
    inputId(){
      this.$router.push('/home-input')
    },
  },
};
</script>

<style lang="less" scoped>
.home-nav{
  position: fixed;
  width: 100%;
  left: 0;
  bottom: 0.20rem;
  box-sizing: border-box;
  display: flex;
}
.home-nav-flex{
  flex: 1;
}
.home-nav-item{
  padding: 0 0.40rem;
}
.home-nav-item .nav-item-btn{
  width: 0.90rem;
  height: 0.90rem;
  background-color: #fff;
  border-radius: 50%;
  padding: 0.20rem;
  box-sizing: border-box;
  box-shadow: 0px 0px 0.10px 0px #BBBBBB;
}
.home-nav-item .nav-item-btn .nav-icon{
  width: 100%;
  height: 100%;
}
.wx-coed-btn{
  width: 3.30rem;
  height: 1.00rem;
  background: linear-gradient(180deg, #2DE8B7 0%, #14CC80 100%);
  box-shadow: 0px 0px 0.10rem 0px #BBBBBB;
  border-radius: 0.50rem;
  border: 0.04rem solid #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.30rem;
  line-height: 0.42rem;
  color: #fff;
}
.nav-item-btn{
  margin: 0.05rem auto;
}
.nav-code-icon{
  width: 0.54rem;
  height: 0.54rem;
  margin-right: 0.30rem;
}

.map-right {
  width: 0.80rem;
  position: absolute;
  right: 0.40rem;
  bottom: 1.85rem;
  box-sizing: border-box;
  text-align: center;
  font-size: 0.20rem;
  line-height: 0.28rem;
  color: #666666;
}
.map-right.move{
  bottom: 5.37rem;
}
.map-location{
  width: 0.80rem;
  height: 0.80rem;
  background-color: #fff;
  border-radius: 50%;
  box-sizing: border-box;
  padding: 0.14rem;
  box-shadow: 0px 0px 0.10px 0px #BBBBBB;
}
.map-location .map-location-icon{
  width: 100%;
  height: 100%;
  vertical-align: top;
}
.map-id{
  margin-top: 0.20rem;
  padding: 0.28rem 0.14rem;
  background-color: #fff;
  border-radius: 0.40rem;
  box-shadow: 0px 0px 0.10px 0px #BBBBBB;
}
.map-id .map-id-icon{
  width: 0.52rem;
  height: 0.62rem;
  vertical-align: top;
}

.map-item-text {
  margin-top:0.05rem;
}
</style>
